import { OpenRequestGeneralCategoriesSalesforce, SelectItemLabelValueCategories } from 'cpes-common';
import { ValidatedSelect, ValidatedSelectItem } from '@cp-shared-19/frontend-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const generalRequestCategories: SelectItemLabelValueCategories[] = [
    ['other-issues-financing', OpenRequestGeneralCategoriesSalesforce.OTHER_ISSUES_FINANCING],
    ['other-issues-operative-leasing', OpenRequestGeneralCategoriesSalesforce.OTHER_ISSUES_OPERATIVE_LEASING],
    ['other-issues-leasing', OpenRequestGeneralCategoriesSalesforce.OTHER_ISSUES_LEASING],
];
export const GeneralRequestDropdown: React.FC<{ name: string }> = ({ name }) => {
    const { t } = useTranslation('my-request');

    const validatedSelectItems: ValidatedSelectItem[] = generalRequestCategories.map((category, index) => {
        const categoryEntryText = t(`form.general-request-categories.${category[0]}`);
        return {
            label: categoryEntryText,
            value: category[1],
            key: index,
        };
    });

    return (
        <>
            <ValidatedSelect
                className="c-form-field--no-floating"
                label={t('form.category.headline')}
                name={name}
                selectItems={validatedSelectItems}
                testId={`general-${name}`}
                placeholder={t('form.category.placeholder')}
                disablePlaceholder={true}
            />
        </>
    );
};
